import React from 'react';
import { getGetChecklistsQueryOptions } from '@area-restrita/api-client/endpoints/hang-tag/hang-tag.gen';

import { useQueryTable } from '@/hooks/useQueryTable';

import { columns } from './columns';
import CheckListSettingsView from './view';

const CheckListSettings: React.FC = () => {
  const {
    table,
    query: { isLoading },
  } = useQueryTable({
    columns,
    getQueryOptions: getGetChecklistsQueryOptions,
  });

  return <CheckListSettingsView isLoading={isLoading} table={table} />;
};

export default CheckListSettings;
